import React, { useState, useEffect, useRef, useContext } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { getFirestore, deleteDoc, updateDoc, arrayUnion, setDoc, collection, getDocs, query, where, doc, getDoc, addDoc } from 'firebase/firestore';

import { db } from '../Firebase/Firebase';
import NavBarV3 from '../Components/NavBarV3';
import Footer from '../Components/footer';
import FloatingMapButton from '../Buttons/FloatingMapButton';
import WhatsAppButton from '../Components/whatsappbutton';
//CARRUECEL PRINCIPAL (RECOMENDADOS)
import Imagen1 from '../img/CarrucelImg1.png';
import Imagen2 from '../img/CarrucelImg2.png';
import Imagen3 from '../img/CarrucelImg3.png';
import Imagen4 from '../img/CarrucelImg4.png';
import Imagen5 from '../img/CarrucelImg5.png';
//CARRUECEL SECUNDARIO (MARCAS)
import Imagen6 from '../img/marca1.jpg';
import Imagen7 from '../img/marca2.jpg';
import Imagen8 from '../img/marca3.jpg';
import Imagen9 from '../img/marca4.jpg';
import Imagen10 from '../img/marca5.jpg';
import Imagen11 from '../img/marca6.jpg';
import Imagen12 from '../img/marca7.jpg';
import Imagen13 from '../img/marca8.jpg';
import SalaReuniones from '../img/SalaReuniones.png';
import SalaPrivada from '../img/SalaPrivada.png';
import SalaEquipos from '../img/SalaEquipos.png';
import Coworking from '../img/CarrucelImg3.png';
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";

import './main.css';
import { useTipoEspacio } from '../Components/context/FiltroTipoEspacioContext';
import MarcasCarrusel from '../Components/carrousels/MarcasCarrusel';
import LoadingScreen from '../Components/loading';
function App() {
    const navigate = useNavigate();
    const { tipoSeleccionado } = useTipoEspacio(); // Obtenemos el tipo seleccionado desde el contexto
    const [sectores, setSectores] = useState([]);
    const [ciudadSeleccionada, setCiudadSeleccionada] = useState('');
    const [detenerAutomatico, setDetenerAutomatico] = useState(false);
    const [sectoresFiltrados, setSectoresFiltrados] = useState([]);
    const [espacios, setEspacios] = useState([]);
    const [currentImageIndex, setCurrentImageIndex] = useState({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchEspacios(tipoSeleccionado);
    }, [tipoSeleccionado]);

    const fetchEspacios = async (idTipoEspacio) => {
        try {
            const auth = getAuth();
            const user = auth.currentUser;
            const userId = user?.uid;

            const queryRef = idTipoEspacio
                ? query(collection(db, 'espacios'), where('TipoEspacio', '==', idTipoEspacio))
                : collection(db, 'espacios');

            const querySnapshot = await getDocs(queryRef);
            const espaciosList = await Promise.all(querySnapshot.docs.map(async (docSnap) => {
                const espacio = { id: docSnap.id, ...docSnap.data() };

                // Verifica si el usuario ha marcado este espacio como favorito
                if (userId) {
                    const favRef = doc(db, "espacios", espacio.id, "favoritos", userId);
                    const favDoc = await getDoc(favRef);
                    espacio.esFavorito = favDoc.exists();
                } else {
                    espacio.esFavorito = false;
                }

                // Obtiene el conteo de favoritos
                const favsSnapshot = await getDocs(collection(db, "espacios", espacio.id, "favoritos"));
                espacio.conteoFavoritos = favsSnapshot.size;

                return espacio;
            }));

            const userLocation = await getUserLocation();
            const espaciosProcesados = userLocation
                ? calcularDistancias(espaciosList, userLocation)
                : espaciosList;

            setEspacios(espaciosProcesados);
            setCurrentImageIndex(inicializarIndicesImagenes(espaciosProcesados));
            setLoading(false);  // Actualizamos el estado de "loading" a false después de cargar los datos

        } catch (error) {
            setLoading(false);  // Actualizamos el estado de "loading" a false después de cargar los datos
        }
    };
    const toggleFavorito = async (espacioId) => {
        const auth = getAuth();
        const user = auth.currentUser;

        if (!user) {
            alert("Debes iniciar sesión para guardar favoritos.");
            return;
        }

        const favRef = doc(db, "espacios", espacioId, "favoritos", user.uid);
        const favDoc = await getDoc(favRef);

        let nuevoEspacios = [...espacios];

        const index = nuevoEspacios.findIndex(e => e.id === espacioId);
        if (index === -1) return;

        try {
            if (favDoc.exists()) {
                await deleteDoc(favRef);

                // 🧠 Actualiza el estado local rápidamente
                nuevoEspacios[index].esFavorito = false;
                nuevoEspacios[index].conteoFavoritos = Math.max(0, nuevoEspacios[index].conteoFavoritos - 1);
            } else {
                await setDoc(favRef, {
                    fecha: new Date()
                });

                nuevoEspacios[index].esFavorito = true;
                nuevoEspacios[index].conteoFavoritos += 1;
            }

            setEspacios(nuevoEspacios);
        } catch (error) {
            console.error("Error al actualizar favorito:", error);
        }
    };


    const handleNextImage = (espacioId, totalImages) => {
        setCurrentImageIndex(prevState => ({
            ...prevState,
            [espacioId]: (prevState[espacioId] + 1) % totalImages
        }));
    };


    const handlePrevImage = (espacioId, totalImages) => {
        setCurrentImageIndex(prevState => ({
            ...prevState,
            [espacioId]: (prevState[espacioId] - 1 + totalImages) % totalImages
        }));
    };

    let temporizador = useRef(null);
    const imagenesCarrucel = [
        { src: Imagen1, url: "/office/espacio_elp85c8kh" },
        { src: Imagen2, url: "/office/espacio_ahe5lkc4g" },
        { src: Imagen3, url: "/office/espacio_y040rifiz" },
        { src: Imagen4, url: "/office/espacio_fhkwt3u0p" },
        { src: Imagen5, url: "/office/espacio_czhxv14gp" },
        { src: Imagen1, url: "/office/espacio_elp85c8kh" },
        { src: Imagen2, url: "/office/espacio_ahe5lkc4g" },
        { src: Imagen3, url: "/office/espacio_y040rifiz" },
        { src: Imagen4, url: "/office/espacio_fhkwt3u0p" },
        { src: Imagen5, url: "/office/espacio_czhxv14gp" },
    ];


    const totalImagenes = imagenesCarrucel.length;
    const [indiceActualCarrucel, setIndiceActualCarrucel] = useState(0); // Comienza en 0 (primera imagen)

    const handleAutoSignOut = () => {
        const auth = getAuth();
        const hasLoggedOut = sessionStorage.getItem("hasLoggedOut");
        if (!hasLoggedOut) {
            signOut(auth)
                .then(() => {
                    console.log("Sesión cerrada automáticamente.");
                    sessionStorage.setItem("hasLoggedOut", "true");
                })
                .catch((error) => {
                    console.error("Error al cerrar sesión:", error);
                });
        }
    };
    handleAutoSignOut();
    const desplazarCarrucel = () => {
        setIndiceActualCarrucel((prevIndice) => {
            if (prevIndice >= totalImagenes - 5) {
                return 0;
            }
            return prevIndice + 1;
        });
    };

    document.addEventListener('DOMContentLoaded', function () {
        const video = document.querySelector('.video-background');
        video.play().catch(error => {
            console.log('Reproducción automática bloqueada:', error);
        });
    });


    useEffect(() => {
        if (ciudadSeleccionada && sectores.has(ciudadSeleccionada)) {
            setSectoresFiltrados(Array.from(sectores.get(ciudadSeleccionada)));
        } else {
            setSectoresFiltrados([]);
        }
    }, [ciudadSeleccionada, sectores]);

    const generateGuestId = () => {
        return `Invitado_${Date.now()}_${Math.floor(Math.random() * 1000)}`;
    };
    const getGuestId = () => {
        const guestIdKey = "guestId";
        let guestId = sessionStorage.getItem(guestIdKey);
        if (!guestId) {
            guestId = generateGuestId();
            sessionStorage.setItem(guestIdKey, guestId);
        }
        return guestId;
    };

    const registrarClic = async (seccion, datosClic) => {
        const auth = getAuth();
        const user = auth.currentUser;
        const nombreUsuario = user?.displayName || "Invitado";
        const [nombre, apellido = ""] = nombreUsuario.split(" ");
        const email = user?.email || "Sin email";
        const userId = user?.uid || getGuestId(); // Si no está autenticado, generar un ID único para el invitado
        const userDocRef = doc(db, "Interacciones", userId);

        try {
            const userDoc = await getDoc(userDocRef);
            if (!userDoc.exists()) {
                await setDoc(userDocRef, {
                    nombre,
                    apellido,
                    email,
                    clics: {}, // Inicializar el mapa de clics
                });
            }
            const userData = userDoc.exists() ? userDoc.data() : {};
            const clicsExistentes = userData.clics?.[seccion] || [];
            const clicExistente = clicsExistentes.find(clic => clic.idEspacio === datosClic.idEspacio);
            const fechaHora = new Date(); // Fecha y hora actual
            if (clicExistente) {
                clicExistente.contador = (clicExistente.contador || 1) + 1;
                clicExistente.fechaHora = fechaHora; // Actualizar la fecha y hora
                await updateDoc(userDocRef, {
                    [`clics.${seccion}`]: [
                        ...clicsExistentes.filter(clic => clic.idEspacio !== datosClic.idEspacio), // Mantener otros clics
                        clicExistente, // Reemplazar el actualizado
                    ],
                });
            } else {
                datosClic.contador = 1;
                datosClic.fechaHora = fechaHora;
                await updateDoc(userDocRef, {
                    [`clics.${seccion}`]: arrayUnion(datosClic),
                });
            }
            console.log(`Clic registrado en la sección "${seccion}" para el usuario:`, datosClic);
        } catch (error) {
            console.error("Error al registrar clic:", error);
        }
    };

    useEffect(() => {
        if (detenerAutomatico) {
            clearInterval(temporizador.current);
            return;
        }

        temporizador.current = setInterval(desplazarCarrucel, 3000); // Cambia cada 3 segundos

        return () => clearInterval(temporizador.current);
    }, [detenerAutomatico, indiceActualCarrucel]);
    const handleClick = async (seccion, titulo, idEspacio) => {
        const datosClic = {
            titulo,
            idEspacio,
            timestamp: new Date().toISOString(), // Agregar marca de tiempo
        };
        try {
            await registrarClic(seccion, datosClic);
            navigate(`/tipos_espacios/${idEspacio}`);
        } catch (error) {
            console.error("Error al registrar clic:", error);
        }
    };
    const [currentSlide, setCurrentSlide] = useState(0);
    const slides = [
        {
            title: "Salas de Reuniones",
            subtitle: (
                <>
                    <ul className="separating-list">
                        <li>Reuniones de equipo o con clientes.</li>
                    </ul>
                </>
            ),
            buttonAction: () => handleClick("TiposEspacios", "Salas de Reuniones", "58jGMk4PIkMe5X6ru1hk"),
            image: SalaReuniones,
            className: "carousel-slide carousel-slide1",
        },
        {
            title: "Oficinas Privadas",
            subtitle: (
                <>
                    <ul className="separating-list">
                        <li>Reuniones privadas y cómodas.</li>
                    </ul>
                </>
            ),
            buttonAction: () => handleClick("TiposEspacios", "Oficinas Privadas", "fKlrgkAvhYESaPuB9y9V"),
            image: SalaPrivada,
            className: "carousel-slide carousel-slide2",
        },
        {
            title: "Oficinas para Equipos",
            subtitle: (
                <>
                    <ul className="separating-list">
                        <li>Espacios para equipos.</li>
                    </ul>
                </>
            ),
            buttonAction: () => handleClick("TiposEspacios", "Oficinas para Equipos", "D5KZfPn43Qow76QEq9oY"),
            image: SalaEquipos,
            className: "carousel-slide carousel-slide3",
        },
        {
            title: "Coworking",
            subtitle: (
                <>
                    <ul className="separating-list">
                        <li>Espacios colaborativos para freelancers.</li>
                    </ul>
                </>
            ),
            buttonAction: () => handleClick("TiposEspacios", "Coworking", "tipoEspacio_pvozqd0m4"),
            image: Coworking,
            className: "carousel-slide carousel-slide5",
        },
    ];


    const nextSlide = () => {
        setCurrentSlide((prevIndex) => (prevIndex + 1) % slides.length);
    };
    const prevSlide = () => {
        setCurrentSlide((prevIndex) => (prevIndex - 1 + slides.length) % slides.length);
    };

    const getVisibleSlides = () => {
        const visibleSlides = [];
        for (let i = 0; i < 3; i++) {
            const slideIndex = (currentSlide + i) % slides.length;
            visibleSlides.push(slides[slideIndex]);
        }
        return visibleSlides;
    };

    const imagenesCarrucelNuevo = [
        { src: Imagen6, url: "https://www.instagram.com/laofi.work/" },
        { src: Imagen7, url: "https://www.instagram.com/logokimia/" },
        { src: Imagen8, url: "https://www.instagram.com/cima_consulting/" },
        { src: Imagen9, url: "https://www.instagram.com/aso.ecuador.emprendedor/" },
        { src: Imagen10, url: "https://www.instagram.com/happybuho/" },
        { src: Imagen11, url: "https://www.instagram.com/romeosjulietas/" },
        { src: Imagen12, url: "https://www.instagram.com/skala_tunegocio/" },
        { src: Imagen13, url: "https://www.instagram.com/lexy.app/" },
    ];

    const [indiceActual, setIndiceActual] = useState(0);
    const [touchStartX, setTouchStartX] = useState(0);
    const [touchEndX, setTouchEndX] = useState(0);
    const avanzar = () => {
        setIndiceActual((prev) => (prev + 1) % imagenesCarrucelNuevo.length);
    };

    const retroceder = () => {
        setIndiceActual((prev) =>
            prev === 0 ? imagenesCarrucelNuevo.length - 1 : prev - 1
        );
    };
    const visibleImages = 7; // Número de imágenes visibles al mismo tiempo
    const imagenesVisibles = [
        ...imagenesCarrucelNuevo,
        ...imagenesCarrucelNuevo, // Duplicado para continuidad
    ].slice(indiceActual, indiceActual + visibleImages);

    // Manejo del toque para deslizar el carrusel
    const handleTouchStart2 = (e) => {
        setTouchStartX(e.touches[0].clientX);
    };

    const handleTouchEnd2 = () => {
        if (touchStartX - touchEndX > 100) {
            avanzar(); // Deslizar a la derecha
        } else if (touchEndX - touchStartX > 100) {
            retroceder(); // Deslizar a la izquierda
        }
    };

    const handleTouchMove2 = (e) => {
        setTouchEndX(e.touches[0].clientX);
    };
    // Hacer que el carrusel se mueva automáticamente
    useEffect(() => {
        const interval = setInterval(() => {
            avanzar();
        }, 3000); // Cambia cada 3 segundos
        return () => clearInterval(interval);
    }, []);

    //Funcion para obtener la ubicacion del usuario
    const getUserLocation = () => {
        return new Promise((resolve, reject) => {
            if (!navigator.geolocation) {
                console.warn("Geolocalización no disponible en este navegador.");
                resolve(null);
            } else {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        const { latitude, longitude } = position.coords;
                        resolve({ latitude, longitude });
                    },
                    (error) => {
                        console.error("Error al obtener ubicación del usuario:", error);
                        resolve(null); // seguimos sin geolocalización
                    }
                );
            }
        });
    };

    const calcularDistancias = (espacios, userLocation) => {
        const { latitude: latUser, longitude: lngUser } = userLocation;

        const distanciaHaversine = (lat1, lon1, lat2, lon2) => {
            const R = 6371; // km
            const dLat = (lat2 - lat1) * Math.PI / 180;
            const dLon = (lon2 - lon1) * Math.PI / 180;
            const a =
                Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
                Math.sin(dLon / 2) * Math.sin(dLon / 2);
            const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            return R * c;
        };

        const espaciosConDistancia = espacios.map(espacio => {
            const { latitud, longitud } = espacio;
            let distancia = null;

            if (latitud != null && longitud != null) {
                distancia = distanciaHaversine(latUser, lngUser, latitud, longitud);
            }

            return { ...espacio, distancia };
        });

        return espaciosConDistancia.sort((a, b) => {
            if (a.distancia == null) return 1;
            if (b.distancia == null) return -1;
            return a.distancia - b.distancia;
        });
    };

    const inicializarIndicesImagenes = (espacios) => {
        const indices = {};
        espacios.forEach(espacio => {
            indices[espacio.id] = 0;
        });
        return indices;
    };
    const handleTouchStart = (e) => {
        setTouchStartX(e.changedTouches[0].clientX);
    };

    const handleTouchEnd = (e, espacioId, totalImages) => {
        setTouchEndX(e.changedTouches[0].clientX);
        const diff = touchStartX - e.changedTouches[0].clientX;

        if (diff > 50) {
            handleNextImage(espacioId, totalImages);
        } else if (diff < -50) {
            handlePrevImage(espacioId, totalImages);
        }
    };

    const goToImage = (espacioId, index) => {
        setCurrentImageIndex(prev => ({
            ...prev,
            [espacioId]: index
        }));
    };


    return (
        <div className='principal-page' >
            {loading ? (<LoadingScreen />) : (
                <>
                    <NavBarV3 />
                    <WhatsAppButton />
                    <br /><br />
                    <FloatingMapButton />
                    <div className="oficinas-container">
                        <div className="oficinas-grid">
                            {espacios.map((espacio) =>
                                espacio.Imagenes && espacio.Imagenes.length > 0 && (
                                    <div key={espacio.id} className="oficina-card">
                                        <div
                                            className="oficina-imagen-wrapper"
                                            onTouchStart={handleTouchStart}
                                            onTouchEnd={(e) => handleTouchEnd(e, espacio.id, espacio.Imagenes.length)}
                                        >

                                            <Link to={`/office/${espacio.IdEspacio}`}>
                                                <img
                                                    src={espacio.Imagenes[currentImageIndex[espacio.id] || 0]}
                                                    alt={espacio.NombreEspacio}
                                                    className="espacio-image"
                                                />
                                            </Link>
                                            <div className="boton-favorito-wrapper">
                                                <button
                                                    className={`boton-favorito ${espacio.esFavorito ? 'activo' : ''} ${espacio.latido ? 'latido' : ''}`}
                                                    onClick={() => toggleFavorito(espacio.id)}
                                                >
                                                    {espacio.esFavorito ? '❤️' : '🖤'}
                                                </button>

                                                {/* <p className="espacio-conteo">
                                            {espacio.conteoFavoritos} ❤️
                                        </p>*/}
                                            </div>




                                            {/* Botones para pantallas grandes */}
                                            {espacio.Imagenes.length > 1 && (
                                                <>
                                                    <button
                                                        className="prev-button"
                                                        onClick={() => handlePrevImage(espacio.id, espacio.Imagenes.length)}
                                                    >
                                                        ❮
                                                    </button>
                                                    <button
                                                        className="next-button"
                                                        onClick={() => handleNextImage(espacio.id, espacio.Imagenes.length)}
                                                    >
                                                        ❯
                                                    </button>
                                                </>
                                            )}

                                            {/* Indicadores circulares */}
                                            {espacio.Imagenes.length > 1 && (
                                                <div className="dots-container">
                                                    {espacio.Imagenes.map((_, index) => (
                                                        <span
                                                            key={index}
                                                            className={`dot ${currentImageIndex[espacio.id] === index ? 'active' : ''}`}
                                                            onClick={() => goToImage(espacio.id, index)}
                                                        />
                                                    ))}
                                                </div>
                                            )}
                                        </div>

                                        <Link to={`/office/${espacio.IdEspacio}`}>
                                            <div className="espacio-content-flex">
                                                <div className="espacio-content">
                                                    <h3 className="espacio-name">{espacio.NombreEspacio}</h3>
                                                    <p className="espacio-capacidad">{espacio.categoriaEspacio != null ? `${espacio.categoriaEspacio}` : ''}</p>
                                                    <p className="espacio-capacidad">{espacio.distancia != null ? `A ${espacio.distancia.toFixed(1)} km de ti` : ''}</p>
                                                    <p className="espacio-capacidad">Capacidad: {espacio.CapacidadMax} personas</p>
                                                </div>

                                                {/*<div className="espacio-rating">
                                            {Array.from({ length: 5 }).map((_, index) => (
                                                <span key={index}>
                                                    {index < Math.round(espacio.calificacion || 0) ? '⭐' : '☆'}
                                                </span>
                                            ))}
                                        </div>*/}
                                                {espacio.calificacion > 0 && (
                                                    <div className="espacio-rating">
                                                        <span className="estrella">⭐</span>
                                                        <span className="calificacion-texto">{espacio.calificacion.toFixed(1)}</span>
                                                    </div>
                                                )}

                                            </div>

                                        </Link>
                                    </div>
                                )
                            )}
                        </div>
                    </div>
                    <MarcasCarrusel />
                    <div className='contenido'>
                        <h2>Descubre Nuestros Espacios</h2>
                        <h3>Explora un entorno diseñado para inspirar y fomentar la productividad. Nuestros espacios combinan estilo y<br></br>
                            funcionalidad para ofrecerte una experiencia única, ya sea trabajando en equipo o de manera individual</h3>
                    </div>
                    <br></br>
                    <div className="carousel-container">
                        <button className="prev-btn" onClick={prevSlide}>❮</button>
                        <div className="carousel-slide-wrapper">
                            {getVisibleSlides().map((slide, index) => (
                                <div
                                    key={index}
                                    className={`${slide.className} ${index === 1 ? 'carousel-slide-center' : ''}`}
                                    onClick={slide.buttonAction} // Redirigir al hacer clic en el slide
                                >
                                    <div className="icon2">
                                        <h2 className='slide-titulo'>{slide.title}</h2>
                                    </div>
                                    <img
                                        src={slide.image}
                                        alt={slide.title}
                                        className={`slide-image image-${typeof slide.title === 'string' ? slide.title.toLowerCase().replace(/ /g, '-') : ''}`}
                                    />

                                    <div className="text-slider">
                                        {slide.subtitle}
                                    </div>
                                </div>
                            ))}
                        </div>
                        <button className="next-btn" onClick={nextSlide}>❯</button>
                    </div>

                    <br /><br />
                    <Footer />

                </>
            )

            }
        </div>
    );
}

export default App;
